import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useEffect,useState} from 'react';
import {useParams,useNavigate} from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';

import AppDashboard from '../AppDashboard';
import SessionTypeForm from '../../components/scheduling/SessionTypeForm';
import LoadingScreen from '../../components/common/LoadingScreen';
import useError from '../../hooks/useError';
import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {
  useGetSessionTypesQuery,
  useUpdateSessionTypeMutation
} from '../../redux/services/sessionTypeApi';

const handleSubmit = ({id, setError, updateSessionType, onBack}) => formData => {
  const res = updateSessionType({id, body: formData});
  if (res.error) return setError({message: res.error});
  setTimeout(() => onBack(), 250);
};

const EditProviderSessionTypePage = props => {
  const navigate = useNavigate();
  const {id} = useParams();
  const providerQuery = useGetCurrentProviderQuery();
  const errors = useError();
  const setError = errors.create;
  const providerId = get(providerQuery, 'data.id');
  const sessionTypesQuery = useGetSessionTypesQuery({id}, {fetch: !!id});
  const [updateSessionType] = useUpdateSessionTypeMutation();
  useEffect(() => {
    sessionTypesQuery.refetch();
  }, []);
  const onBack = () => navigate(`/providers/${providerId}/session-types/list`);
  const childProps = {
    ...props,
    sessionType: get(sessionTypesQuery, 'data', []).find(
      s => s.id === parseInt(id, 10)
    ),
    isEditingExistingSessionType: true,
    setError: err => errors.create(err),
    onCancel: onBack,
    onSubmit: handleSubmit({id, setError, updateSessionType, onBack}),
  };
  if (sessionTypesQuery.isFetching) return <LoadingScreen />;
  return (
    <AppDashboard
      title='Session Type'
      backgroundColor='#F9F9F9'
      loading={sessionTypesQuery.isLoading}
      onBack={onBack}
    >
      {
        childProps.sessionType
        ? <SessionTypeForm
            warning={{message: 'Any changes you make will not apply to existing appointments that have already been scheduled.'}}
          {...childProps } 
          />
        : null
      }
    </AppDashboard>
  );
};

EditProviderSessionTypePage.defaultProps = {
};

EditProviderSessionTypePage.propTypes = {
};

export default EditProviderSessionTypePage;
